import React from 'react'
import { Button, Col, Radio, Row, Space } from 'antd';
import * as locCon from "../LocalConstants"
import * as libCon from "../community-hats-js-library/Constants.js"
import { StateStoredValue } from '../hooks/GeneralStoreHooks';
import { LanguageState } from '../hooks/LanguageHooks';
import BackButton from '../elements/BackButton';
import HomeButton from '../elements/HomeButton';

// Each language is labeled in its own script, so it stays recognizable to a
// reader who cannot read the currently selected one.
const LANGUAGES = [
    { locale: libCon.EN, label: "EN" },
    { locale: libCon.ES, label: "ES" },
    { locale: libCon.HI, label: "ह" },
    { locale: libCon.GU, label: "ગુ" }]


function Header({ showBackButton = true }) {

    const [userType, setUserType] = StateStoredValue(locCon.USER_TYPE)
    const [i18n, currentLocale, setCurrentLocale] = LanguageState()

    return (
        <div style={{ width: "100%", marginTop: "1vh" }}>
            <Row style={{ width: "100%" }}>

                <Col span={12} style={{ paddingLeft: "1vw", display: "flex", justifyContent: "flex-start" }}>
                    <div style={{ marginRight: "1vw" }}><HomeButton /></div>
                    {

                        showBackButton ? <BackButton /> : <div></div>
                    }
                </Col>
                <Col span={12} style={{ paddingRight: "1vw", display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: "1vw" }}>
                    <Radio.Group onChange={(e) => setUserType(e.target.value)} value={userType}>
                        <Space direction="horizontal">
                            <Radio style={{ color: "white", fontSize: "14px" }} value={locCon.USER_TYPE_SEWA}>{i18n.t('sewa')}</Radio>
                            <Radio style={{ color: "white", fontSize: "14px" }} value={locCon.USER_TYPE_OUTSIDE_COLLABORATOR}>{i18n.t('outsideCollaborator')}</Radio>
                        </Space>
                    </Radio.Group>
                    <Space direction="horizontal" size={4}>
                        {
                            LANGUAGES.map(({ locale, label }) =>
                                <Button
                                    key={locale}
                                    size="small"
                                    type={currentLocale === locale ? "primary" : "default"}
                                    onClick={() => setCurrentLocale(locale)}>
                                    {label}
                                </Button>)
                        }
                    </Space>
                </Col>


            </Row>
        </div >
    )
}

export default Header
